export const WEEKLY_UTILIZATION_TITLE = 'Weekly Utilization Report';

const today = new Date();
const selectedDate = [today.getFullYear(), String(today.getMonth() + 1).padStart(2, '0'),
  String(today.getDate()).padStart(2, '0')].join('-');

const globalFilter = (field, header, item) => ({
  field,
  header,
  visible: false,
  filter: true,
  sortable: false,
  pinnable: false,
  defaultPinned: false,
  showPinButtonInHeader: false,
  showFilterButtonInHeader: false,
  isGlobalFilter: true,
  menuItems: [{ label: header, items: [{ type: 'filter', field, label: header, ...item }] }],
});

export const weeklyUtilizationFilters = [
  globalFilter('selectedDate', 'Date', {
    template: 'dayCalendar',
    placeholder: 'Select Date',
    calendarOverlayConfig: { panelClassName: 'custom-calendar-panel' },
    selectedValue: selectedDate,
    selectedValues: [selectedDate],
  }),
  globalFilter('sections', 'Sections', {
    template: 'multiSelect',
    placeholder: 'Select Sections',
    selectedValues: [WEEKLY_UTILIZATION_TITLE],
    options: [{ label: WEEKLY_UTILIZATION_TITLE, value: WEEKLY_UTILIZATION_TITLE }],
  }),
];

export const weeklyUtilizationColumns = [
  { field: 'employeeVertical', header: 'Employee Vertical', width: 240 },
  { field: 'strength', header: 'Strength', width: 140 },
  { field: 'bench', header: 'Bench', width: 140 },
  { field: 'training', header: 'Training', width: 140 },
  { field: 'internalProject', header: 'Internal Project', width: 140 },
  { field: 'unUtilized', header: 'Unutilized', width: 140 },
  { field: 'utilizationPercentage', header: 'Utilization %', width: 180 },
].map((column) => ({
  ...column,
  visible: true,
  filter: false,
  sortable: false,
  pinnable: false,
  defaultPinned: false,
  showPinButtonInHeader: false,
  showFilterButtonInHeader: false,
  numeric: ['strength', 'bench', 'training',
    'internalProject', 'unUtilized', 'utilizationPercentage'].includes(column.field),
}));

export const defaultWeeklyUtilAppliedFilters = weeklyUtilizationFilters.map(({ field, menuItems }) => {
  const { selectedValue = null, selectedValues = [] } = menuItems[0].items[0];
  return { field, selectedValue, selectedValues, value: selectedValue ?? selectedValues };
});

// Filters live in the Staffing MIS toolbar, so drop them from the report table columns.
export const handleWeeklyUtilizationResponse = (response) => {
  const report = response.data?.weeklyUtilization || response.data || response;
  const columns = (report.tableConfiguration || weeklyUtilizationColumns)
    .filter((column) => !column.isGlobalFilter)
    .map((column) => ({ ...column, pinnable: false, defaultPinned: false, showPinButtonInHeader: false }));
  response.tableConfiguration = columns;
  if (response.data) response.data.tableConfiguration = response.tableConfiguration;
};
